import { Component,h, Prop } from '@stencil/core';


@Component({
    tag: 'card-icon',
    shadow: false
})
export class CardIcon {
    @Prop() svgStyle: any = {};
    @Prop() width: number = 21;
    @Prop() height: number = 15;

    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" style={this.svgStyle} width={this.width} height={this.height} viewBox="0 0 20 14">
                <slot />
                <path d="M19.531,0.489C19.843,0.814,20,1.209,20,1.67v1.996H0V1.67c0-0.461,0.17-0.855,0.51-1.181C0.849,0.164,1.236,0,1.67,0 h16.659C18.819,0,19.219,0.164,19.531,0.489z M19.531,13.511C19.219,13.836,18.819,14,18.329,14H1.67 c-0.434,0-0.821-0.17-1.16-0.509C0.17,13.151,0,12.765,0,12.33V5.691h20v6.639C20,12.792,19.843,13.185,19.531,13.511z"></path>
            </svg>
        );
    }
}






